import React from 'react'
import { connect } from 'react-redux';
import SelectBox from 'containers/LoanApplication/components/commons/SelectBox'

class RepaymentType extends React.Component {

  onChange = (value) => {
    this.props.onChange(value)
  }

  render() {
    const {
      checked
    } = this.props;

    return(
      <div>
        <div className='form-group mb-0'>
          <label>What type of repayment would you prefer?</label>
        </div>
        <div className='row no-gutters mb-3'>
          <div className='col-12 col-sm-5 mr-2'>
            <SelectBox
              checked={ checked == 'principal_and_interest' }
              value='principal_and_interest'
              text='Principal & interest'
              onChange={ this.onChange }
             />
          </div>

          <div className='col-12 col-sm-5 mr-2'>
            <SelectBox
              checked={ checked == 'interest_only' }
              value='interest_only'
              text='Interest only'
              onChange={ this.onChange }
             />
          </div>
        </div>
      </div>
    )
  }
}

export default RepaymentType;
